// extracted by mini-css-extract-plugin
export default {"formWrap":"Login_formWrap__HBgNM","section":"Login_section__xWEWG"};